import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_URL}/api/logs`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("tokenInv");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  };
};

export const fetchActivity = async (page = 1, perPage = 10, filters = {}) => {
  const { action, from_date, to_date } = filters;
  const response = await axios.get(API_BASE_URL, {
    headers: getAuthHeaders(),
    params: {
      page,
      per_page: perPage,
      action,
      from_date,
      to_date,
    },
  });
  return response.data;
};


